/**
 * Standard noop function. Use this instead of instantiating a new function each time to reduce memory load.
 */
export const noop = () => {}
